import { getExperimentValue } from './data/DataStore';

const flags = {
	professionalReviews: true,
	onTheShelf: (ots = true) => ots,
	useAmplitudeLogger: true,
	experimentAboutThisBookToBelowRelatedContent: () => getExperimentValue('aboutthisbook-belowrelatedcontent', 'enabled') === true ? true : false,
	novelistSelectUiVersion: () => getExperimentValue('novelist-select-ui-version', 'uiVersion') === 4 ? true : false,
	aboutthisbookCarousel: () => getExperimentValue('about-this-book-carousel', 'enabled') === true ? true : false,
	aboutthisbookCarouselVersion: () => getExperimentValue('about-this-book-carousel-version', 'version') === 2 ? 2 : 1,
	useNewLogging: () => getExperimentValue('novelist-select-ui-logging-using-fetch', 'enabled') === true ? true : false,
}

export default flags;



// WEBPACK FOOTER //
// ./src/featureFlags.js